<template>
  <div class="mobile-timeseries-control">
    <div class="d-flex align-center play-button-area">
      <v-btn fab x-small depressed @click="previous">
        <v-icon>mdi-skip-previous</v-icon>
      </v-btn>
      <v-btn v-if="isRunning" fab x-small depressed @click="pause">
        <v-icon>mdi-pause</v-icon>
      </v-btn>
      <v-btn v-else fab x-small depressed @click="play">
        <v-icon>mdi-play</v-icon>
      </v-btn>
      <v-btn fab x-small depressed @click="next">
        <v-icon>mdi-skip-next</v-icon>
      </v-btn>
    </div>
    <div class="center-area">
      <div class="center-time" />
    </div>
    <div id="times-area" class="times-area" v-on:scroll="handleScroll">
      <div class="time white-space" ref="timeWhiteSpace" />
      <div
        class="time"
        v-for="(info, index) in selectedRiskContents"
        :key="index"
        :id="'time' + index"
        :ref="'time' + index"
      >
        <span class="date" v-if="moment.utc(info.date).isSame(riskBaseDate)">
          現在<br
        /></span>
        <span class="date" v-else
          >{{
            moment
              .utc(info.date)
              .local()
              .lang("ja", {
                weekdays: ["日", "月", "火", "水", "木", "金", "土"]
              })
              .format("MM/DD (dd)")
          }}<br
        /></span>
        <span>{{
          moment
            .utc(info.date)
            .local()
            .format("HH:mm")
        }}</span>
      </div>
      <div class="time white-space" />
    </div>
  </div>
</template>

<script>
import { Risk } from "../../../enums/Risk";
import moment from "moment";
import VueScrollTo from "vue-scrollto";

export default {
  name: "MobileTimeSeriesControl",
  data() {
    return {
      Risk,
      isRunning: false,
      runningInterval: null,
      moment,
      timeWhiteSpace: 0,
      highLightTimeIndex: 0
    };
  },
  computed: {
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    selectedRiskContents() {
      if (this.selectedRisk.key === Risk.RAIN.key) {
        return this.$store.getters.rainImageInfo;
      } else if (
        this.selectedRisk.key === Risk.RIVER_FLOODING.key &&
        this.$store.getters.riverFloodingInfo.length > 0
      ) {
        return this.$store.getters.riverFloodingInfo[0].images;
      } else if (
        this.selectedRisk.key === Risk.DOSYA.key &&
        this.$store.getters.dosyaInfo.images !== undefined
      ) {
        return this.$store.getters.dosyaInfo.images;
      } else if (
        this.selectedRisk.key === Risk.SNOW.key &&
        this.$store.getters.snowInfo.images !== undefined
      ) {
        return this.$store.getters.snowInfo.images;
      } else if (
        this.selectedRisk.key === Risk.KOUZUI.key &&
        this.$store.getters.kouzuiInfo !== undefined
      ) {
        return this.$store.getters.kouzuiInfo;
      } else {
        return [];
      }
    },
    selectedDate() {
      return this.$store.getters.selectedDate;
    },
    riskBaseDate() {
      return this.$store.getters.riskBaseDate;
    }
  },
  async mounted() {
    this.timeWhiteSpace = this.$refs.timeWhiteSpace.clientWidth;
  },
  watch: {
    selectedRiskContents() {
      this.scrollToCurrentTime();
    }
  },
  methods: {
    handleScroll(e) {
      const timeWidth = 64;
      const highlightTimeIndex = e.target.scrollLeft / timeWidth;
      this.updateHighlightTimeIndex(Math.round(highlightTimeIndex));
    },
    scrollToIndex(index) {
      if (index < 0 || index >= this.selectedRiskContents.length) {
        return;
      }
      VueScrollTo.scrollTo("#time" + index, 100, {
        container: "#times-area",
        easing: "linear",
        offset: -this.timeWhiteSpace,
        x: true,
        y: false
      });
    },
    updateHighlightTimeIndex(targetIndex) {
      if (targetIndex < 0 || targetIndex >= this.selectedRiskContents.length) {
        return;
      }
      this.highLightTimeIndex = targetIndex;
      const content = this.selectedRiskContents[this.highLightTimeIndex];
      if (content) {
        this.$store.commit(
          "SET_SELECTED_DATE",
          moment.utc(content.date, "YYYY/MM/DD HH:mm")
        );
      }
    },
    async scrollToCurrentTime() {
      await this.$nextTick();
      const currentIndex = this.selectedRiskContents.findIndex(row =>
        moment.utc(row.date, "YYYY/MM/DD HH:mm").isSame(this.selectedDate)
      );
      if (currentIndex !== -1) {
        this.scrollToIndex(currentIndex);
        this.highLightTimeIndex = currentIndex;
      }
    },
    scrollAndUpdateHighlightTimeIndex(targetIndex) {
      this.scrollToIndex(targetIndex);
      this.updateHighlightTimeIndex(targetIndex);
    },
    next() {
      this.scrollAndUpdateHighlightTimeIndex(this.highLightTimeIndex + 1);
    },
    previous() {
      this.scrollAndUpdateHighlightTimeIndex(this.highLightTimeIndex - 1);
    },
    play() {
      this.runningInterval = setInterval(() => {
        if (this.highLightTimeIndex < this.selectedRiskContents.length - 1) {
          this.scrollAndUpdateHighlightTimeIndex(this.highLightTimeIndex + 1);
        } else {
          this.pause();
        }
      }, 1000);
      this.isRunning = true;
    },
    pause() {
      clearInterval(this.runningInterval);
      this.isRunning = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../common";

$time-width: 64px;

.mobile-timeseries-control {
  background-color: rgba(44, 50, 76, 0.9);
  height: 100%;
}

.play-button-area {
  height: 30px;
  gap: 10px;
  padding-left: 10px;
  .v-btn--fab.v-size--x-small {
    width: 24px;
    height: 24px;
  }
}

.center-area {
  display: flex;
  justify-content: center;
  position: relative;
  height: 5px;
}

.center-time {
  width: $time-width;
  height: 5px;
  background-color: orange;
  border-radius: 5px;
}

.times-area {
  overflow: auto;
  white-space: nowrap;
  scroll-snap-type: x mandatory; /* Chrome Canary */
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.time {
  scroll-snap-align: center;
  padding: 3px 0 3px 0;
  color: white;
  font-size: 13px;
  display: inline-block;
  vertical-align: bottom;
  width: $time-width;
  height: 100%;
  touch-action: manipulation;
  white-space: normal;
  text-align: center;
}

.time .date {
  font-size: 10px;
  text-align: center;
}

.white-space {
  width: calc(50% - 32px);
  touch-action: manipulation;
}
</style>
